<template>
  <div id="app" class="bg-dark">
    <LandingPage v-if="firstVisit" v-on:go-to-home="goToHome()" />
    <Page v-else />
  </div>
</template>

<script>
import LandingPage from "./views/LandingPage.vue";
import Page from "./views/Page.vue";

export default {
  name: "App",
  data() {
    return { firstVisit: true };
  },
  components: {
    Page,
    LandingPage,
  },
  methods: {
    goToHome() {
      this.firstVisit = false;
    },
  },
};
</script>
